import { ApiError } from './api/client'
import { getAnalyticsActor, posthog } from './posthog'

/**
 * Người bán bấm "Sao chép đơn" ở chi tiết đơn (M-187), mỗi lần bấm một event
 * `sales_order_duplicated` khi request kết thúc:
 *   - `result`: `created` (đã có đơn nháp mới) / `failed`.
 *   - `source_status`: trạng thái đơn gốc lúc bấm (khách mua lại đơn đã xong
 *     hay đơn đang dở).
 *   - `line_count`: số dòng hàng của đơn gốc (chép đơn nhiều dòng mới là chỗ
 *     tiết kiệm công nhập lại).
 *   - `new_order_id` (khi created) để nối với DB xem bản sao có được xác nhận.
 *   - `failure` (khi failed): mã lỗi API, hoặc `network` khi không có phản hồi.
 *
 * Không gửi tên khách, số điện thoại, giá hay mã sản phẩm. Analytics lỗi hoặc
 * tắt không được chặn việc sao chép.
 */
export function captureOrderDuplicate(input: {
    sourceOrderId: string
    sourceStatus: string
    lineCount: number
    newOrderId?: string
    error?: unknown
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        const failed = input.error !== undefined
        posthog.capture('sales_order_duplicated', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            result: failed ? 'failed' : 'created',
            source_order_id: input.sourceOrderId,
            source_status: input.sourceStatus,
            line_count: input.lineCount,
            ...(failed
                ? {
                      failure:
                          input.error instanceof ApiError
                              ? input.error.code
                              : 'network',
                  }
                : { new_order_id: input.newOrderId }),
        })
    } catch {
        // Analytics không được chặn việc sao chép đơn.
    }
}
